import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

/**
 * Card primitive — mirrors `.ez-card` from design/app-tokens.css.
 * `padding="md"` (default) maps to `.ez-card-pad` (20px), `lg` to
 * `.ez-card-pad-lg` (24px). Use `none` when the card hosts its own header /
 * sectioned layout.
 */
const cardVariants = cva('bg-surface border border-line rounded-lg', {
  variants: {
    padding: {
      none: '',
      md: 'p-5',
      lg: 'p-6',
    },
  },
  defaultVariants: {
    padding: 'md',
  },
});

export interface CardProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, padding, ...props }, ref) => {
    return <div ref={ref} className={cn(cardVariants({ padding }), className)} {...props} />;
  },
);
Card.displayName = 'Card';

export { cardVariants };
